// CALL_INTEGRATION loan action — maps the package/method pair between the loan-action
// form shape and the API shape. The backend LoanActionType subtype is
// `CallIntegrationMethod(IntegrationPackageId, MethodId, TimedSequenceOptions, Environment)`, so the
// API field is `integrationPackageId` (NOT `packageId`) and the action-type discriminator is
// `CallIntegrationMethod` (see LoanEditorActionsEnum.CALL_INTEGRATION). The form keeps a
// flat `callIntegration.packageId` internally; this maps it to the API contract both ways.
// Extracted from LoanActionTransformations.utils.js to keep that file within the max-lines budget.

import { integrationEnvironmentOptions } from 'constants/loanActionEditor';

// HZ-4015: environment is stored in the form as the selected option object (mirroring signingMethod)
// and carried on the API as the bare enum-name string. A null/absent value means "inherit deployment"
// — the executor tier-derives it — so it must round-trip untouched rather than defaulting to an env.
const getEnvironmentFormOption = environment =>
  integrationEnvironmentOptions.find(({ value }) => value === environment) ?? null;

export const getCallIntegrationApiFormat = (formItem, common) => {
  const item = formItem.callIntegration ?? {};

  return {
    ...common,
    integrationPackageId: item.packageId ?? null,
    methodId: item.methodId ?? null,
    environment: item.environment?.value ?? null,
  };
};

export const getCallIntegrationFormFormat = (actionItem, itemType, timedSequenceOptions) => ({
  itemType,
  timedSequenceOptions,
  callIntegration: {
    packageId: actionItem.integrationPackageId ?? null,
    methodId: actionItem.methodId ?? null,
    environment: getEnvironmentFormOption(actionItem.environment),
  },
});
